import type { AgeInterval } from "@/types/parameter/parameter";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function removeExtension(fileName: string): string {
	const parts = fileName.split(".");
	if (!parts || parts.length <= 1) return fileName;
	parts.pop();
	return parts.join(".");
}

export function capitalizeFirstLetter(str: string): string {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

export function sleep(ms: number): Promise<void> {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export function isAgeInterval(obj: AgeInterval): obj is AgeInterval {
	return (
		typeof obj === "object" &&
		obj !== null &&
		typeof obj.minAge === "string" &&
		typeof obj.maxAge === "string" &&
		typeof obj.value === "string"
	);
}

export function isValidAgeIntervals(input: AgeInterval[]): boolean {
	if (!Array.isArray(input) || !input.every(isAgeInterval)) {
		return false;
	}
	return true;
}

export function toFixedNumber(num: number, decimalPlaces: number = 2): number {
	const factor = Math.pow(10, decimalPlaces);
	return Math.round(num * factor) / factor;
}
